import { render, staticRenderFns } from "./DashboardHeaderComponent.vue?vue&type=template&id=ee55336a&scoped=true"
import script from "./DashboardHeaderComponent.vue?vue&type=script&lang=js"
export * from "./DashboardHeaderComponent.vue?vue&type=script&lang=js"
import style0 from "./DashboardHeaderComponent.vue?vue&type=style&index=0&id=ee55336a&prod&scoped=true&lang=scss"
import style1 from "./DashboardHeaderComponent.vue?vue&type=style&index=1&id=ee55336a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee55336a",
  null
  
)

export default component.exports